import { render, staticRenderFns } from "./rf-culture.vue?vue&type=template&id=0ca89434&scoped=true&"
import script from "./rf-culture.vue?vue&type=script&lang=js&"
export * from "./rf-culture.vue?vue&type=script&lang=js&"
import style0 from "./rf-culture.vue?vue&type=style&index=0&id=0ca89434&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca89434",
  null
  
)

export default component.exports